import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./CheckBoxIcon.styles";
import { FontAwesomeIcon } from "./FontAwesome";

interface CheckBoxIconProps {
    checked: boolean;
    hover?: boolean;
    active?: boolean;
    disabled?: boolean;
    backgroundless?: boolean;
}

export function CheckBoxIcon({
    checked,
    disabled,
    hover,
    active,
    backgroundless: gridRendering,
}: CheckBoxIconProps) {
    const theme: any = useTheme();
    const classes = useStyles({ theme });
    const { CheckBoxIconType, TickedImageUrl, UntickedImageUrl } = theme;
    const {
        PrimaryColor,
        ControlBorderColor,
        ChoiceListBackgroundAlpha,
        ChoiceListBackgroundBorderWidth,
    } = theme;
    const selectedColor = disabled ? ControlBorderColor : PrimaryColor;
    let borderColor = ControlBorderColor;

    const showDefaultIconForCustomCondition =
        CheckBoxIconType === "custom" &&
        ((!checked && UntickedImageUrl === "") || (checked && TickedImageUrl === ""));
    const showDefaultIcon = CheckBoxIconType === "default" || showDefaultIconForCustomCondition;

    const backgroundless =
        gridRendering || (ChoiceListBackgroundAlpha === 0 && ChoiceListBackgroundBorderWidth === 0);
    if (backgroundless) borderColor = active || checked ? selectedColor : ControlBorderColor;
    if (hover) borderColor = selectedColor;
    return (
        <span
            className={classnames(
                "fa-layers fa-fw",
                classes.checkBoxIcon,
                checked && classes.checkBoxIconChecked,
                disabled && classes.checkBoxIconDisabled,
            )}
        >
            {showDefaultIcon && (
                <div>
                    <FontAwesomeIcon
                        icon={["fas", "square-full"]}
                        style={{
                            transition: "color 200ms",
                            color: borderColor,
                            transform: `scale(${21 / 23})`,
                        }}
                    />
                    <FontAwesomeIcon
                        icon={["fas", "square-full"]}
                        color="#fff"
                        style={{
                            transition: "transform 200ms",
                            fontSize: "21px",
                            transform: checked && !backgroundless ? "" : `scale(${17 / 21})`,
                        }}
                    />
                    <FontAwesomeIcon
                        icon={["fas", "check"]}
                        color={selectedColor}
                        style={{
                            transition: "opacity 200ms",
                            opacity: checked ? 1 : 0,
                        }}
                        transform="shrink-6"
                    />
                </div>
            )}
            {CheckBoxIconType === "custom" && !checked && UntickedImageUrl !== "" && (
                <img className="custom__Image" src={UntickedImageUrl} alt="Unticked" />
            )}
            {CheckBoxIconType === "custom" && checked && TickedImageUrl !== "" && (
                <img className="custom__Image" src={TickedImageUrl} alt="Ticked" />
            )}
        </span>
    );
}
